<div class="p-4 bg-gray-50 rounded shadow">
    <mat-tab-group>
        <mat-tab label="Details">
            <h2 class="text-lg font-semibold text-gray-800 mb-4"
                >{{ _translocoContent()['grid.rowDetailsTitle'] }}
            </h2>
            <div *ngIf="selectedRowSignal() as selectedRow">
                <formly-form
                    [form]="form"
                    [fields]="fields()"
                    [model]="selectedRowSignal()"></formly-form>
            </div>
            <div *ngIf="!selectedRowSignal()" class="text-gray-500">
                {{ _translocoContent()['grid.noSelected'] }}</div
            >
        </mat-tab>
        <mat-tab label="Description">
            <custom-ck-editor
                *ngIf="form.controls.description"
                [formGroup]="form"
                fcName="description"></custom-ck-editor>
        </mat-tab>
    </mat-tab-group>
</div>
